import { render } from "../templates/scenario-assessment.html?vue&type=template&id=48c8f626"
import script from "./ScenarioAssessment.vue?vue&type=script&lang=js"
export * from "./ScenarioAssessment.vue?vue&type=script&lang=js"

import "./ScenarioAssessment.vue?vue&type=style&index=0&id=48c8f626&lang=css"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__